// extracted by mini-css-extract-plugin
export var dropdownContainer = "_50-5";
export var imageContainer = "_50-4";
export var metricsGrid = "_50-2";
export var productDetailContainer = "_50-1";
export var productListContainer = "_50-0";
export var subscriberTableContainer = "_50-3";